import { Image, ImageProps } from 'expo-image';
import React from 'react';

export type UberEatsLogoProps = Omit<ImageProps, 'source'>;

/** The Uber Eats wordmark, shared by every screen that credits the delivery provider. */
export function UberEatsLogo(props: UberEatsLogoProps) {
  return <Image source={require('./uber-eats.webp')} {...props} />;
}
